

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import axios, { buildVideoIndexerManifestUrl, buildVideoIndexerCaptionsUrl } from "../../API/axios";
import Hls from 'hls.js';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import { WLJ_FEED_PLYR_OPTIONS } from '../../utils/plyrFeedOptions';

function CircularProgressWithLabel(props) {


    return (
        <Box sx={{
            position: 'relative',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 250,
            background: '#000'
        }}>
            {props.reFresh ? (
                <Box>
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: '#FFFFFF', cursor: 'pointer' }}
                    // onClick={props.checkVideoStatus}
                    >
                        Retry
                    </Typography>
                </Box>
            ) : (
                <Box>
                    <CircularProgress variant="determinate" color="inherit" thickness={4} sx={{ color: '#FFFFFF' }} {...props} />
                    <Box
                        sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="caption"
                            component="div"
                            sx={{ color: '#FFFFFF' }}
                        >
                            {`${Math.round(props.value)}%`}
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
    reFresh: PropTypes.bool,
    // checkVideoStatus: PropTypes.func,
};

const PostVideoCommon = ({ file,
    // restrictedViewerToken,
    item, setActiveVideoId, activeVideoId, setPostList, visibleVideoRef }) => {
    const [progress, setProgress] = useState(parseInt(file?.videoIndexInsight?.processingProgress?.replace('%', ''), 10) || 0);
    const [apiCount, setApiCount] = useState(0);
    const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
    const language = localStorage.getItem("Lang");

    // const [PostList, setPostList] = useState(0);
    const [reFresh, setRefresh] = useState(false);
    const [showPlayer, setShowPlayer] = useState(false);
    const videoRef = useRef(null);
    const [videoProcessingDone, setVideoProcessingDone] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [hasFetchedPost, setHasFetchedPost] = useState(false);
    const [shouldRenderIframe, setShouldRenderIframe] = useState(false);
    const containerRef = useRef(null);
    const isFullscreen = useRef(false);




    const isProcessed = file?.videoIndexInsight?.state === "Processed";
    const isError = file?.videoIndexInsight?.status === "Error";
    const isThisVideoActive = activeVideoId === file?.mediaInfo;

    const checkVideoStatus = async () => {
        try {
            const reqData = {
                deviceType: "Web",
                postId: item?.postInfo?.postId,
                videoID: file.mediaInfo,
                restrictedViewerToken: restrictedViewerToken,
                langKey: language === "en" ? "" : language,

            };

            const res = await axios.post(`Posts/GetVideoIndexInsight`, reqData);
            if (res?.data?.status === "Success") {
                setApiCount((prev) => prev + 1);
                const percentage = parseInt(res?.data?.responseData?.processingProgress.replace('%', ''), 10);
                setProgress(percentage);
                return percentage === 100;
            } else {
                return false;
            }
        } catch (e) {
            console.error(e);
            return false;
        }
    };

    useEffect(() => {
        if (isError) {
            checkVideoStatus()
        }
    }, [isError])
    //  const checkVideoStatus = async () => {
    //         try {
    //             const reqData = {
    //                 deviceType: "Web",
    //                 postId: item?.postInfo?.postId,
    //                 videoID: file?.mediaInfo,
    //                 restrictedViewerToken: restrictedViewerToken
    //             };
    //             setRefresh(false);
    //             const res = await axios.post(`Posts/GetVideoIndexInsight`, reqData);
    //             if (res?.data?.status === 'Success') {
    //                 setApiCount(prev => prev + 1);
    //                 const percentage = parseInt(res?.data?.responseData?.processingProgress.replace('%', ''), 10);
    //                 setProgress(percentage); 
    //             } else {
    //                 setRefresh(true);
    //             }
    //         } catch (e) {
    //             console.error(e);
    //             setRefresh(true);
    //         }
    //     };

    //     useEffect(() => {
    //         if (progress < 100) {
    //             const interval = setTimeout(() => {
    //                 checkVideoStatus();
    //             }, 3000); // Poll every 3s
    //             return () => clearTimeout(interval);
    //         }  
    //     }, [progress, apiCount]);


    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         ([entry]) => {
    //             const isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6;

    //             if (isVisible) {
    //                 setShowPlayer(true);

    //                 if (isProcessed && typeof setActiveVideoId === "function") {
    //                     setActiveVideoId(file?.mediaInfo);

    //                     if (activeVideoId === file?.mediaInfo) {
    //                         setShouldRenderIframe(true);
    //                     }
    //                 }
    //             } else { 
    //                 setShowPlayer(false);

    //                 if (activeVideoId === file?.mediaInfo) {
    //                     setActiveVideoId("");
    //                     setShouldRenderIframe(false); // optional: stop iframe rendering
    //                 }
    //             }
    //         },
    //         { threshold: [0.6] }
    //     );

    //     const el = videoRef.current;
    //     if (el) observer.observe(el);

    //     return () => {
    //         if (el) observer.unobserve(el);
    //     };
    // }, [file?.mediaInfo, isProcessed, setActiveVideoId, activeVideoId]);

    // ...................................
    // useEffect(() => {
    //   const observer = new IntersectionObserver(
    //     (entries) => {
    //       const entry = entries[0];
    //       const ratio = entry.intersectionRatio;

    //       // Only act if intersecting and at least 0.6 visible
    //       if (entry.isIntersecting && ratio >= 0.6) {
    //         // Only set active if no video is active or this one is more visible
    //         const current = visibleVideoRef.current;

    //         if (
    //           !current ||                   // no video is active
    //           current.ratio < ratio ||     // this one is more visible
    //           current.mediaId === file?.mediaInfo // same video
    //         ) {
    //           visibleVideoRef.current = {
    //             mediaId: file?.mediaInfo,
    //             ratio: ratio
    //           };

    //           if (isProcessed && typeof setActiveVideoId === "function" && activeVideoId !== file?.mediaInfo) {
    //             setActiveVideoId(file?.mediaInfo);
    //           }

    //           setShowPlayer(true);
    //         }
    //       } else {
    //         // If this video is not the most visible, don't allow autoplay
    //         if (visibleVideoRef.current?.mediaId === file?.mediaInfo) {
    //           visibleVideoRef.current = null;
    //           setShowPlayer(false);
    //         }

    //         if (activeVideoId === file?.mediaInfo) {
    //           setActiveVideoId("");
    //         }
    //       }
    //     },
    //     { threshold: Array.from({ length: 11 }, (_, i) => i * 0.1) }
    //   );

    //   const el = videoRef.current;
    //   if (el) observer.observe(el);

    //   return () => {
    //     if (el) observer.unobserve(el);
    //   };
    // }, [file?.mediaInfo, isProcessed, setActiveVideoId, activeVideoId]);



    // useEffect(() => {
    //   setShouldRenderIframe(activeVideoId === file?.mediaInfo);
    // }, [activeVideoId, file?.mediaInfo]);

    // .......................video tag ....................

    // useEffect(() => {
    //     const timeout = setTimeout(() => {
    //         if (!containerRef.current) return;

    //         const videoEl = containerRef.current.querySelector(`video[data-video-id="${file?.mediaInfo}"]`);
    //         if (!videoEl || !videoEl.parentNode) return;

    //         const manifest = buildVideoIndexerManifestUrl({ videoId: file?.mediaInfo, accessToken: restrictedViewerToken });

    //         let hls;
    //         let plyr;

    //         if (Hls.isSupported()) {
    //             hls = new Hls();
    //             hls.loadSource(manifest);
    //             hls.attachMedia(videoEl);
    //             hls.on(Hls.Events.MANIFEST_PARSED, () => {
    //                 plyr = new Plyr(videoEl, {
    //                     captions: { active: true, update: true, language: "en" },
    //                 });
    //             });
    //         } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
    //             videoEl.src = manifest;
    //             plyr = new Plyr(videoEl, {
    //                 captions: { active: true, update: true, language: "en" },
    //             });
    //         }

    //         return () => {
    //             // try {
    //             //     if (plyr) plyr.destroy();
    //             //     if (hls) hls.destroy();
    //             // } catch (e) {
    //             //     console.warn("Cleanup failed", e);
    //             // }
    //              return () => {
    //                     try {
    //                     if (plyr && typeof plyr.destroy === 'function') {
    //                         plyr.destroy();
    //                     }
    //                     if (hls && typeof hls.destroy === 'function') {
    //                         hls.destroy();
    //                     }
    //                     } catch (e) {
    //                     console.warn("Cleanup failed", e); // safe fallback
    //                     }
    //                 };
    //         };
    //     }, 300); // Defer setup

    //     return () => clearTimeout(timeout);
    // }, [shouldRenderIframe, file?.mediaInfo, restrictedViewerToken]);

    useEffect(() => {
        if (!containerRef.current || !file?.mediaInfo) return;

        const videoEl = containerRef.current.querySelector(`video[data-video-id="${file.mediaInfo}"]`);
        if (!videoEl || !videoEl.parentNode) return;

        let hls;
        let plyr;
        let hasInitialized = false;

        const initPlayer = () => {
            const manifest = buildVideoIndexerManifestUrl({ videoId: file.mediaInfo, accessToken: restrictedViewerToken });

            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(manifest);
                hls.attachMedia(videoEl);

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    plyr = new Plyr(videoEl, WLJ_FEED_PLYR_OPTIONS);
                    videoEl.muted = true; // always start muted
                    videoEl.play().catch((e) =>
                        console.warn("Autoplay error", e));
                });
            } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
                videoEl.src = manifest;
                plyr = new Plyr(videoEl, WLJ_FEED_PLYR_OPTIONS);
                videoEl.play().catch((e) => console.warn("Autoplay error", e));
            }
        };

        const observer = new IntersectionObserver(
            ([entry]) => {
                const isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6;

                if (isFullscreen.current) return;

                if (isVisible) {
                    if (!hasInitialized) {
                        hasInitialized = true;
                        initPlayer();
                    }

                    const prev = visibleVideoRef?.current;
                    if (
                        prev &&
                        prev.mediaId !== file?.mediaInfo &&
                        prev.videoEl &&
                        !prev.videoEl.paused
                    ) {
                        prev.videoEl.pause();
                    }

                    visibleVideoRef.current = {
                        mediaId: file?.mediaInfo,
                        videoEl,
                    };

                    if (videoEl.paused) {
                        // videoEl.muted = true; // always start muted
                        videoEl.play().catch((err) => console.warn("Autoplay error", err));
                    }

                    if (setActiveVideoId && activeVideoId !== file?.mediaInfo) {
                        setActiveVideoId(file?.mediaInfo);
                    }
                } else {
                    if (
                        visibleVideoRef?.current?.mediaId === file?.mediaInfo &&
                        !videoEl.paused
                    ) {
                        videoEl.pause();
                        visibleVideoRef.current = null;
                        if (setActiveVideoId) {
                            setActiveVideoId("");
                        }
                    }
                }
            },
            {
                threshold: [0, 0.1, 0.25, 0.5, 0.6, 0.75, 1],
            }
        );

        observer.observe(videoEl);

        return () => {
            observer.unobserve(videoEl);
            try {
                videoEl.pause();
                if (hls && typeof hls.destroy === "function") {
                    hls.destroy();
                }
            } catch (e) {
                console.warn("HLS cleanup failed", e);
            }

            const plyrInstance = plyr;
            if (plyrInstance && typeof plyrInstance.destroy === "function") {
                // Defer Plyr teardown so React can unmount the post card first.
                // plyr.destroy() removes wrapper nodes and causes removeChild errors in production.
                setTimeout(() => {
                    try {
                        plyrInstance.destroy();
                    } catch (e) {
                        console.warn("Plyr cleanup failed", e);
                    }
                }, 0);
            }
        };
    }, [file?.mediaInfo, restrictedViewerToken]);


    // useEffect(() => {
    //   if (!containerRef.current || !file?.mediaInfo) return;

    //   const videoEl = containerRef.current.querySelector(`video[data-video-id="${file.mediaInfo}"]`);
    //   if (!videoEl || !videoEl.parentNode) return;

    //   let hls;
    //   let plyr;
    //   let hasInitialized = false;

    //   const observer = new IntersectionObserver(
    //     (entries) => {
    //       const entry = entries[0];

    //       if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && !hasInitialized) {
    //         hasInitialized = true;

    //         const timeout = setTimeout(() => {
    //           const manifest = buildVideoIndexerManifestUrl({ videoId: file.mediaInfo, accessToken: restrictedViewerToken });

    //           if (Hls.isSupported()) {
    //             hls = new Hls();
    //             hls.loadSource(manifest);
    //             hls.attachMedia(videoEl);
    //             hls.on(Hls.Events.MANIFEST_PARSED, () => {
    //               plyr = new Plyr(videoEl, {
    //                 captions: { active: true, update: true, language: "en" },
    //               });
    //               videoEl.play().catch((e) => console.warn("Autoplay error", e));
    //             });
    //           } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
    //             videoEl.src = manifest;
    //             plyr = new Plyr(videoEl, {
    //               captions: { active: true, update: true, language: "en" },
    //             });
    //             videoEl.play().catch((e) => console.warn("Autoplay error", e));
    //           }
    //         }, 300); // Delay to ensure DOM is stable

    //         return () => clearTimeout(timeout);
    //       }
    //     },
    //     {
    //       threshold: [0, 0.25, 0.5, 0.6, 0.75, 1],
    //     }
    //   );

    //   observer.observe(videoEl);

    //   return () => {
    //     observer.disconnect();
    //     try {
    //       if (plyr && typeof plyr.destroy === "function") {
    //         plyr.destroy();
    //       }
    //       if (hls && typeof hls.destroy === "function") {
    //         hls.destroy();
    //       }
    //     } catch (e) {
    //       console.warn("Cleanup failed", e);
    //     }
    //   };
    // }, [file?.mediaInfo, restrictedViewerToken]);


    useEffect(() => {
        const handleFullscreenChange = () => {
            isFullscreen.current = !!document.fullscreenElement;
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);

    // useEffect(() => {
    // const videoEl = videoRef.current;
    // if (!videoEl) return;

    // const observer = new IntersectionObserver(
    //     ([entry]) => {
    //     const ratio = entry.intersectionRatio;
    //     const isVisible = entry.isIntersecting && ratio >= 0.6;

    //     if (isFullscreen.current) {
    //         // Don't autoplay/pause when in fullscreen
    //         return;
    //     }

    //     if (isVisible) {
    //         const prev = visibleVideoRef.current;

    //         if (
    //         prev &&
    //         prev.mediaId !== file?.mediaInfo &&
    //         prev.videoEl &&
    //         !prev.videoEl.paused
    //         ) {
    //         prev.videoEl.pause();
    //         }

    //         visibleVideoRef.current = {
    //         mediaId: file?.mediaInfo,
    //         videoEl: videoEl,
    //         };

    //         if (isProcessed && videoEl.paused) {
    //         videoEl.play().catch((err) => console.warn("Autoplay error", err));
    //         }

    //         if (setActiveVideoId && activeVideoId !== file?.mediaInfo) {
    //         setActiveVideoId(file?.mediaInfo);
    //         }
    //     } else {
    //         // Only pause if this was the active video and not fullscreen
    //         if (
    //         visibleVideoRef.current?.mediaId === file?.mediaInfo &&
    //         !videoEl.paused
    //         ) {
    //         videoEl.pause();
    //         visibleVideoRef.current = null;
    //         if (setActiveVideoId) {
    //             setActiveVideoId("");
    //         }
    //         }
    //     }
    //     },
    //     {
    //     threshold: Array.from({ length: 11 }, (_, i) => i * 0.1),
    //     }
    // );

    // observer.observe(videoEl);
    // return () => {
    //     observer.unobserve(videoEl);
    // };
    // }, [file?.mediaInfo, isProcessed, activeVideoId]);


    return (

        <>
            <div style={{ position: "relative", width: "100%", height: "auto", display: "flex", justifyContent: "center", alignItems: "center" }}
                ref={containerRef} className="post-video-common-container w-100">

                {progress < 100 ? (
                    <CircularProgressWithLabel
                        value={progress}
                        reFresh={reFresh}
                    // checkVideoStatus={checkVideoStatus}
                    />
                ) : (
                    <>

                        {/* {shouldRenderIframe  ? (
                            // <iframe
                            // style={{paddingBottom: '50px',marginTop:'-1px', 
                            // }}
                            //     key={file?.mediaInfo}
                            //     width="100%"
                            //     height="300"
                            //     src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=true`}
                            //     frameBorder="0"
                            //     allow="autoplay"
                            //     allowFullScreen
                                
                            // /> */}

                        <video
                            key={`video-${file?.mediaInfo}`}
                            ref={videoRef}
                            data-video-id={file?.mediaInfo}
                            id={`player-${file?.mediaInfo}`}
                            playsInline
                            controls
                            muted
                            crossOrigin="true"
                            poster={`data:image/jpeg;base64,${file?.videoIndexInsight?.thumbnail}`}
                            className="w-100 rounded shadow feed-post-video-player"
                            style={{ objectFit: "contain", height: "auto", maxHeight: "85vh", maxWidth: "100%" }}
                        >
                            <track
                                kind="subtitles"
                                label="English"
                                srcLang="en"
                                src={buildVideoIndexerCaptionsUrl({ videoId: file?.mediaInfo, accessToken: restrictedViewerToken })}
                                default
                            />
                        </video>
                        {/* ) : (
                            <>
                                <img
                                    src={`data:image/jpeg;base64,${file?.videoIndexInsight?.thumbnail}`}
                                    alt="Video Thumbnail"
                                    style={{ width: "100%", height: "300px", objectFit: "cover" }}
                                />
                                <div
                                    onClick={() => {
                                        if (typeof setActiveVideoId === "function") {
                                            setActiveVideoId(file?.mediaInfo);
                                        }
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        background: "rgba(0,0,0,0.6)",
                                        borderRadius: "50%",
                                        padding: "10px 15px 10px 17px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <span style={{ fontSize: "20px", color: "#fff" }}>▶</span>
                                </div>
                            </>
                        )} */}
                    </>
                )}
            </div>

        </>

    );
};

export default PostVideoCommon;
